// Module
var code = "<kform-html-element component=\"component\"></kform-html-element> ";
// Exports
export default code;